import React from 'react';
import './About.css';

const About = () => {
  return (
    <section id="about" className="about-section">
      {/* Intro Section */}
      <div className="about-intro">
        <h1>GalaxyAdvisors: Connecting Innovation and Collaboration</h1>
        <p>
          At GalaxyAdvisors AG, we believe innovation thrives in collaboration. Founded in 2007 in Aarau, Switzerland, and Boston, MA, our journey builds on over 20 years of MIT research to enhance teamwork and creativity through advanced social network analysis of email and social media.
        </p>
      </div>

      {/* Main Sections */}
      <div className="about-sections">
        <div className="about-section-item">
          <h2>Our Vision</h2>
          <p>
            'Don’t Be a Star, Be a Galaxy.' This guiding principle reflects our belief that great ideas emerge when individuals come together as part of a connected whole. Collaboration is the spark that fuels innovation, creativity, and problem-solving.
          </p>
        </div>
        <div className="about-section-item">
          <h2>Global Impact</h2>
          <p>
            For over a decade, our tools and methodologies have empowered global leaders to:
          </p>
          <ul>
            <li>Strengthen collaboration across teams.</li>
            <li>Foster creativity in solving complex challenges.</li>
            <li>Improve risk management strategies.</li>
            <li>Enhance customer insights and research.</li>
          </ul>
          <p>
            In the past we have worked with leading companies such as Airbus, Ford, BMW, BASF, Bayer, ExxonMobil, Pfizer, UBS, Citibank, HSBC, ING, and many more.
          </p>
        </div>
        <div className="about-section-item">
          <h2>Innovative Solutions</h2>
          <p>
            Recognizing the importance of data privacy, we’ve pioneered solutions that empower individuals to take control of their information. Our cutting-edge apps, developed to align with GDPR privacy restrictions, include:
          </p>
          <ul>
            <li><strong>SocialCompass</strong>: An AI-powered job coach transforming career development.</li>
            <li><strong>WaggyDog</strong>: A FaunaAI app dedicated to enhancing pet well-being.</li>
            <li><strong>Biolingo</strong>: AI-driven plant biosensors fostering a deeper understanding of plant health and measuring human emotions.</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default About;
